module.exports = __webpack_public_path__ + "static/assets/2c3775a2efad59dc14cee711049c4095.png";